/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerFacility
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerFacility {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerFacility
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerFacility
     */
    id: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerFacility interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerFacility(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerFacility {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerFacility {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerFacility {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerFacilityToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
    };
}

